var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SalesMaster',{attrs:{"addNew":"/inventory/do/","type":"DO"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }